try {
// ============================================================
// len-lop.js — CHUYỂN NĂM HỌC: LÊN LỚP
// Đăng ký 1 thẻ vào màn Quản trị qua window.qtTabPhu.
// Cần 3 hàm của sql/35-len-lop.sql.
//
// VÌ SAO CÓ MÀN NÀY: cau_hinh.nam_hoc_tu_dong = 'co', mốc sang năm học mới là
// 30/8. Qua mốc đó mà chưa chuyển năm thì màn Học sinh, màn Phân lớp về điểm
// trường và mọi con số theo điểm trường ở Điều hành đều trống — dữ liệu năm cũ
// vẫn nguyên, nhưng năm mới chưa có dòng nào.
//
// MÀN NÀY KHÔNG TỰ LÀM GÌ CẢ. Máy chỉ đếm hộ và gợi ý tên lớp; ba việc dưới
// đây là quyết định của nhà trường, đều phải bấm nút mới chạy:
//   · xác nhận học sinh hoàn thành chương trình (thẩm quyền Hiệu trưởng —
//     Điều 9 TT27/2020, app chưa có màn nhập kết quả cuối năm);
//   · sửa tên lớp đích (sáp nhập xong ba điểm trường có thể trùng tên lớp);
//   · xếp lớp cho học sinh ở lại lớp — máy KHÔNG xếp thay.
// ============================================================
(function () {
  'use strict';

  function thoat(s) { return window.thoatHTML ? window.thoatHTML(s) : String(s || ''); }
  function batLoi(e) { window.notify('Không chạy được: ' + ((e && e.message) || e)); }

  // Hỏi ý người dùng bằng hộp thoại của app (js/hop-thoai.js) thay cho confirm()
  // của trình duyệt — cái đó đề "chaudinh.quantrisotruonghoc.com cho biết", chữ
  // dồn cục, trông như trang web hỏng chứ không phải phần mềm của nhà trường.
  // Vẫn giữ đường lui về confirm() phòng khi hop-thoai.js chưa nạp kịp: thà xấu
  // còn hơn nút bấm không ra gì cả.
  function xinPhep(noiDung, tuyChon) {
    return window.hopHoi ? window.hopHoi(noiDung, tuyChon || {})
                         : Promise.resolve(window.confirm(noiDung));
  }

  // Năm học kế tiếp: '2025-2026' → '2026-2027'. Sai định dạng thì trả rỗng
  // để ô nhập trống, admin tự gõ — đoán bừa một năm học là hỏng cả kho dữ liệu.
  function namKeTiep(nam) {
    var m = /^(\d{4})\s*-\s*(\d{4})$/.exec(String(nam || ''));
    if (!m) return '';
    return (parseInt(m[1], 10) + 1) + '-' + (parseInt(m[2], 10) + 1);
  }

  var NAM_NGUON = '', NAM_DICH = '';

  // ── Đọc hết bảng lớn theo trang 1000 dòng (mẫu chung của dự án) ──
  // BẮT BUỘC có .order(): PostgREST không hứa thứ tự nào nếu không sắp xếp,
  // phân trang bằng .range() có thể lấy lặp dòng trang trước và bỏ sót dòng
  // khác. 863 em × 2 năm học đã vượt trần 1000 dòng của Supabase — không
  // phân trang thì DANH SÁCH NĂM BỊ THIẾU, màn này chọn sai năm nguồn.
  function taiHet(bang, cot, loc) {
    var ket = [], tu = 0, buoc = 1000;
    function trang() {
      var q = window.MAY_CHU.from(bang).select(cot).order('id').range(tu, tu + buoc - 1);
      (loc || []).forEach(function (l) { q = q.eq(l[0], l[1]); });
      return q.then(function (r) {
        if (r.error) throw r.error;
        var d = r.data || [];
        ket = ket.concat(d);
        if (d.length < buoc) return ket;
        tu += buoc;
        return trang();
      });
    }
    return trang();
  }

  // Canh năm đích. Gõ nhầm ở ô này là đổ TOÀN BỘ học sinh lên lớp vào chính
  // năm đang chạy, mà màn này KHÔNG có đường lùi — nên chặn ngay từ đầu vào.
  // Trả về chuỗi lỗi, rỗng nghĩa là hợp lệ.
  function loiNamDich(nguon, dich) {
    if (!/^\d{4}-\d{4}$/.test(dich)) return 'Năm học mới phải viết dạng 2026-2027.';
    var a = dich.split('-'), d1 = parseInt(a[0], 10), d2 = parseInt(a[1], 10);
    if (d2 !== d1 + 1) return 'Năm học mới phải là hai năm liền nhau, ví dụ 2026-2027 — ' +
      'thầy cô đang gõ "' + dich + '".';
    if (dich === nguon) return 'Năm học mới TRÙNG năm học nguồn (' + nguon + ').\n\n' +
      'Chạy như vậy là đổ học sinh lên lớp vào chính năm đang học, và màn này ' +
      'KHÔNG có đường lùi. Hãy sửa ô năm học mới.';
    var n = /^(\d{4})-\d{4}$/.exec(String(nguon || ''));
    if (n && d1 <= parseInt(n[1], 10)) return 'Năm học mới (' + dich + ') phải SAU ' +
      'năm học nguồn (' + nguon + ').';
    return '';
  }

  function veTabLL(hop) {
    hop.innerHTML = '<div class="the-thong-bao">Đang tải…</div>';

    // Năm nguồn mặc định = năm CÓ DỮ LIỆU mới nhất, KHÔNG phải năm hệ thống
    // đang chạy. Sau 30/8 hệ thống nhảy sang 2026-2027 mà dữ liệu vẫn nằm ở
    // 2025-2026 — lấy năm hệ thống thì màn này mở ra trống trơn đúng lúc cần
    // nó nhất. (Cùng bài học đã ghi ở hocsinh.js.)
    taiHet('hoc_sinh_lop', 'id, nam_hoc').then(function (ds) {
      var dsNam = [];
      (ds || []).forEach(function (d) {
        if (d.nam_hoc && dsNam.indexOf(d.nam_hoc) < 0) dsNam.push(d.nam_hoc);
      });
      dsNam.sort();
      if (!dsNam.length) {
        hop.innerHTML = '<div class="the-thong-bao">Chưa có dữ liệu học sinh năm nào — ' +
          'chưa có gì để chuyển lên lớp.</div>';
        return;
      }
      NAM_NGUON = NAM_NGUON || dsNam[dsNam.length - 1];
      NAM_DICH = NAM_DICH || namKeTiep(NAM_NGUON);
      veBang(hop, dsNam);
    })
      // Không có nhánh này thì mất mạng là kẹt "Đang tải…" vĩnh viễn,
      // không một lời nào cho thầy cô biết vì sao.
      .catch(function (e) {
        hop.innerHTML = '<div class="the-thong-bao">Không đọc được dữ liệu học sinh: ' +
          thoat((e && e.message) || e) +
          '<br><br><button class="nut-phu nut-ll-tai-lai">Thử lại</button></div>';
        var n = hop.querySelector('.nut-ll-tai-lai');
        if (n) n.addEventListener('click', function () { veTabLL(hop); });
      });
  }

  function veBang(hop, dsNam) {
    var may = window.MAY_CHU;
    may.rpc('xem_len_lop', { p_nam_nguon: NAM_NGUON, p_nam_dich: NAM_DICH })
      .then(function (r) {
        if (r.error) {
          hop.innerHTML = '<div class="the-thong-bao">Không xem trước được: ' +
            thoat(r.error.message) +
            '<br><br>Nếu báo không tìm thấy hàm thì chạy <b>sql/35-len-lop.sql</b> trên Supabase.' +
            '<br><br><button class="nut-phu nut-ll-tai-lai">Thử lại</button></div>';
          var n0 = hop.querySelector('.nut-ll-tai-lai');
          if (n0) n0.addEventListener('click', function () { veTabLL(hop); });
          return;
        }
        var ds = r.data || [];
        var tong = { si: 0, len: 0, oLai: 0, chua: 0, ra: 0, thoi: 0, daCo: 0 };
        ds.forEach(function (d) {
          tong.si += d.si_so; tong.len += d.se_len_lop; tong.oLai += d.o_lai_lop;
          tong.chua += d.chua_co_ket_qua; tong.ra += d.ra_truong;
          tong.thoi += d.khong_con_hoc; tong.daCo += d.da_co_nam_dich;
        });

        hop.innerHTML =
          daiChonNam(dsNam) +
          daiTomTat(tong) +
          daiBang(ds) +
          // Hàng xác nhận HÀNG LOẠT — đặt NGAY DƯỚI bảng, tách khỏi nút lên
          // lớp bên dưới nữa: hai việc khác hẳn nhau, để cạnh nhau là có ngày
          // bấm nhầm. Chỉ hiện khi còn lớp trống kết quả.
          (tong.chua ? '<div class="ll-hang-chon">' +
            '<button class="nut-phu-nd nut-xac-nhan-chon" disabled>✓ Xác nhận hoàn thành</button>' +
            '<span class="ll-dem">Tích chọn các lớp cần xác nhận kết quả cả năm.</span>' +
            '</div>' : '') +
          '<div style="margin-top:14px">' +
          '<button class="nut-chinh nut-lam-len-lop">🎓 Thực hiện lên lớp</button> ' +
          '<span class="ll-nhac" style="font-size:12.5px;color:var(--chu-mo)"></span></div>' +
          daiChanTrang();

        noiSuKien(hop, dsNam, ds, tong);
      })
      .catch(function (e) {
        hop.innerHTML = '<div class="the-thong-bao">Không xem trước được: ' +
          thoat((e && e.message) || e) +
          '<br><br><button class="nut-phu nut-ll-tai-lai">Thử lại</button></div>';
        var n = hop.querySelector('.nut-ll-tai-lai');
        if (n) n.addEventListener('click', function () { veTabLL(hop); });
      });
  }

  function daiChonNam(dsNam) {
    return '<div class="dau-muc" style="text-align:left;margin:14px 0 10px">' +
      '<div class="nhan-nho">Chuyển năm học</div></div>' +
      '<div class="dh-chon-hang" style="flex-wrap:wrap;margin-bottom:12px">' +
      '<span style="font-size:13px;align-self:center">Từ năm học</span>' +
      '<select class="dh-o-nhap ll-nam-nguon" style="width:auto;margin-top:0">' +
      dsNam.map(function (n) {
        return '<option value="' + thoat(n) + '"' + (n === NAM_NGUON ? ' selected' : '') +
          '>' + thoat(n) + '</option>';
      }).join('') + '</select>' +
      '<span style="font-size:13px;align-self:center">sang năm học</span>' +
      // Ô CHỌN, không gõ tay. Đây là màn KHÔNG CÓ ĐƯỜNG LÙI: gõ nhầm một chữ số
      // là đổ cả trường lên lớp vào một năm học không tồn tại. Danh sách gồm ba
      // năm dùng chung của app cộng năm kế tiếp năm nguồn (trường nạp bù dữ
      // liệu cũ thì năm kế tiếp có thể nằm ngoài ba năm ấy).
      '<select class="dh-o-nhap ll-nam-dich" style="width:auto;margin-top:0">' +
      (function () {
        var ds = window.baNamHoc ? window.baNamHoc([namKeTiep(NAM_NGUON), NAM_DICH])
                                 : [namKeTiep(NAM_NGUON)];
        return ds.map(function (n) {
          return '<option value="' + thoat(n) + '"' + (n === NAM_DICH ? ' selected' : '') +
            '>' + thoat(n) + '</option>';
        }).join('');
      })() + '</select>' +
      '<button class="nut-vien nut-doi-nam">Xem lại</button>' +
      '</div>';
  }

  function daiTomTat(t) {
    // Chỗ nào là 0 vẫn hiện — người dùng cần thấy "0 em chưa có kết quả" chứ
    // không phải một ô biến mất không rõ vì sao.
    var o = function (nhan, so, mau) {
      return '<div class="ll-o' + (mau ? ' ' + mau : '') + '"><b>' + so + '</b><span>' + nhan + '</span></div>';
    };
    return '<div class="ll-tom-tat">' +
      o('Đang học năm cũ', t.si) +
      o('Sẽ lên lớp', t.len, 'xanh') +
      o('Ở lại lớp', t.oLai, t.oLai ? 'vang' : '') +
      o('Chưa có kết quả', t.chua, t.chua ? 'do' : '') +
      o('Hoàn thành tiểu học', t.ra) +
      o('Đã có ở năm mới', t.daCo) +
      '</div>' +
      (t.chua
        ? '<div class="hd-kiem do"><b>⚠ ' + t.chua + ' học sinh chưa có kết quả cả năm.</b><br>' +
          'Những em này <b>sẽ không được chuyển</b> sang năm học mới. Chưa nhập kết quả ' +
          'khác hẳn với không được lên lớp, nên máy không tự quyết. Ở cột cuối bảng dưới ' +
          'đây có nút <b>Xác nhận hoàn thành</b> cho từng lớp — bấm là ghi kết quả cho ' +
          'những em còn trống của lớp đó, kết quả giáo viên đã nhập thì không bị đụng vào.</div>'
        : '') +
      (t.oLai
        ? '<div class="hd-kiem vang"><b>' + t.oLai + ' học sinh ở lại lớp.</b> ' +
          'Máy KHÔNG tự xếp các em này vào lớp nào của năm mới — xếp lớp cho học sinh ' +
          'lưu ban là việc của nhà trường. Chuyển năm xong, vào trang Lớp học xếp tay.</div>'
        : '');
  }

  function daiBang(ds) {
    if (!ds.length) return '<div class="the-thong-bao">Năm học này không có lớp nào.</div>';
    return '<div class="cuon-ngang"><table class="bang-quan-tri nho" id="ll-bang"><thead><tr>' +
      '<th>Lớp cũ</th><th>Điểm trường</th><th>Sĩ số</th><th>Lên lớp</th><th>Ở lại</th>' +
      '<th>Chưa có KQ</th><th>Lớp mới</th>' +
      '<th style="width:52px;text-align:center" title="Chọn để xác nhận kết quả cả năm">' +
      '<input type="checkbox" class="ll-chon-het"></th></tr></thead><tbody>' +
      ds.map(function (d) {
        var raTruong = d.khoi_nguon === 5;
        return '<tr data-lop="' + thoat(d.lop_nguon) + '">' +
          '<td><b>' + thoat(d.lop_nguon) + '</b></td>' +
          '<td>' + thoat(d.co_so_ma || '—') + '</td>' +
          '<td style="text-align:center">' + d.si_so + '</td>' +
          '<td style="text-align:center">' + (raTruong ? '—' : d.se_len_lop) + '</td>' +
          '<td style="text-align:center">' + (d.o_lai_lop || '') + '</td>' +
          '<td style="text-align:center">' +
          (d.chua_co_ket_qua ? '<b style="color:var(--thieu)">' + d.chua_co_ket_qua + '</b>' : '') + '</td>' +
          '<td>' + (raTruong
            ? '<span style="color:var(--chu-mo)">Hoàn thành chương trình tiểu học</span>'
            : '<input class="ll-lop-moi dh-o-nhap" style="width:90px;margin-top:0" value="' +
              thoat(d.lop_dich_goi_y || '') + '">') + '</td>' +
          // Ô TÍCH thay cho nút riêng từng lớp. 20 lớp mà mỗi lớp một nút, mỗi
          // nút một hộp xác nhận là 40 cú bấm — thầy Chung góp ý 22/8/2026.
          // Lớp nào đã đủ kết quả thì không có ô tích, khỏi bấm nhầm.
          '<td style="text-align:center">' + (d.chua_co_ket_qua
            ? '<input type="checkbox" class="ll-chon" data-so="' + d.chua_co_ket_qua + '">' : '') + '</td>' +
          '</tr>';
      }).join('') +
      '</tbody></table></div>';
  }

  function daiChanTrang() {
    return '<div class="nhan-nho" style="margin-top:14px;text-transform:none;letter-spacing:0;color:var(--chu-mo)">' +
      'Lên lớp <b>không xoá gì</b> của năm cũ và <b>chạy lại được</b> — em nào đã có ở năm mới ' +
      'thì bỏ qua, không nhân đôi. Lớp mới sinh ra <b>kế thừa điểm trường của lớp cũ</b>, nên không ' +
      'phải phân lại 25 lớp từ đầu. Học sinh lớp 1 tuyển mới và học sinh hai trường nhập về ' +
      'nạp riêng, màn này không đụng tới.</div>';
  }

  function noiSuKien(hop, dsNam, ds, tong) {
    var may = window.MAY_CHU;

    hop.querySelector('.nut-doi-nam').addEventListener('click', function () {
      var nguon = hop.querySelector('.ll-nam-nguon').value;
      var dich = hop.querySelector('.ll-nam-dich').value.trim();
      var loi = loiNamDich(nguon, dich);
      if (loi) { window.alert(loi); return; }
      NAM_NGUON = nguon; NAM_DICH = dich;
      veTabLL(hop);
    });

    // ── XÁC NHẬN KẾT QUẢ CẢ NĂM CHO NHIỀU LỚP MỘT LƯỢT ──────────────────
    // Tích lớp nào thì xác nhận lớp ấy, một hộp hỏi duy nhất ở cuối. Cố ý
    // KHÔNG làm nút "xác nhận tất cả" bấm cái là xong: đây là tuyên bố cả
    // trường hoàn thành chương trình, thẩm quyền Hiệu trưởng — người bấm phải
    // nhìn thấy mình đang tích những lớp nào và bao nhiêu em.
    var nutChon = hop.querySelector('.nut-xac-nhan-chon');
    var oDem = hop.querySelector('.ll-dem');
    var chonHet = hop.querySelector('.ll-chon-het');
    var oChon = Array.prototype.slice.call(hop.querySelectorAll('.ll-chon'));

    function dangChon() { return oChon.filter(function (o) { return o.checked; }); }

    function capNhatDem() {
      if (!nutChon) return;
      var c = dangChon();
      var em = c.reduce(function (s, o) { return s + (parseInt(o.getAttribute('data-so'), 10) || 0); }, 0);
      nutChon.disabled = !c.length;
      nutChon.textContent = c.length
        ? '✓ Xác nhận hoàn thành cho ' + c.length + ' lớp'
        : '✓ Xác nhận hoàn thành';
      oDem.textContent = c.length
        ? em + ' học sinh sẽ được ghi kết quả hoàn thành chương trình.'
        : 'Tích chọn các lớp cần xác nhận kết quả cả năm.';
      if (chonHet) {
        chonHet.checked = c.length === oChon.length && oChon.length > 0;
        chonHet.indeterminate = c.length > 0 && c.length < oChon.length;
      }
    }

    oChon.forEach(function (o) { o.addEventListener('change', capNhatDem); });
    if (chonHet) {
      chonHet.addEventListener('change', function () {
        oChon.forEach(function (o) { o.checked = chonHet.checked; });
        capNhatDem();
      });
    }
    capNhatDem();

    if (nutChon) {
      nutChon.addEventListener('click', function () {
        var c = dangChon();
        if (!c.length) return;
        var dsLop = c.map(function (o) { return o.closest('tr').getAttribute('data-lop'); });
        var em = c.reduce(function (s, o) { return s + (parseInt(o.getAttribute('data-so'), 10) || 0); }, 0);

        xinPhep(
          'Xác nhận HOÀN THÀNH chương trình cho ' + em + ' học sinh còn trống kết quả, ' +
          'thuộc ' + dsLop.length + ' lớp — năm học ' + NAM_NGUON + '?\n\n' +
          'Các lớp: ' + dsLop.join(' · ') + '\n\n' +
          'Đây là thẩm quyền của Hiệu trưởng (Điều 9 Thông tư 27/2020). Nhật ký ghi lại ' +
          'ai xác nhận, lúc nào — mỗi lớp một dòng.\n\n' +
          'Em nào giáo viên đã ghi kết quả rồi thì KHÔNG bị đụng tới.',
          { tieuDe: 'Xác nhận kết quả cả năm', bieuTuong: '🎓', nutOK: 'Xác nhận ' + dsLop.length + ' lớp' }
        ).then(function (dongY) {
          if (!dongY) return;
          nutChon.disabled = true;
          if (chonHet) chonHet.disabled = true;
          oChon.forEach(function (o) { o.disabled = true; });

          // Gọi TUẦN TỰ, không bắn một loạt: 20 lệnh ghi song song vào cùng một
          // bảng vừa dễ nghẽn vừa khó nói lớp nào hỏng khi có lỗi.
          var xong = 0, tongEm = 0, hong = [];
          function lamTiep(i) {
            if (i >= dsLop.length) return Promise.resolve();
            nutChon.textContent = 'Đang xác nhận ' + (i + 1) + '/' + dsLop.length + '…';
            return may.rpc('xac_nhan_ket_qua_lop',
              { p_nam_hoc: NAM_NGUON, p_lop: dsLop[i], p_len_lop: true })
              .then(function (r) {
                if (r.error) throw r.error;
                xong++; tongEm += (r.data && r.data.so_hoc_sinh) || 0;
              })
              .catch(function (e) { hong.push(dsLop[i] + ' (' + ((e && e.message) || e) + ')'); })
              .then(function () { return lamTiep(i + 1); });
          }

          lamTiep(0).then(function () {
            // Báo RÕ cả phần hỏng. Lặng lẽ bỏ qua vài lớp lỗi là kiểu hỏng
            // nguy hiểm nhất ở màn này: nhìn vào tưởng xong cả trường.
            if (hong.length) {
              window.alert('Đã xác nhận ' + xong + '/' + dsLop.length + ' lớp (' + tongEm + ' học sinh).\n\n' +
                '🔴 KHÔNG xác nhận được ' + hong.length + ' lớp:\n· ' + hong.join('\n· '));
            } else {
              window.notify('Đã xác nhận ' + tongEm + ' học sinh của ' + xong + ' lớp.');
            }
            veTabLL(hop);
          });
        });
      });
    }

    // Thực hiện lên lớp
    hop.querySelector('.nut-lam-len-lop').addEventListener('click', function () {
      var nut = this;

      // Hàng rào cuối. Bảng đang hiện được vẽ theo NAM_NGUON/NAM_DICH lúc nạp;
      // thầy cô sửa ô năm rồi bấm thẳng nút này (không bấm "Xem lại") thì con
      // số trong bảng là của cặp năm CŨ mà lệnh lại chạy cho cặp năm nào?
      // Chặn hẳn, bắt xem lại — chứ không đoán ý.
      var oNguon = hop.querySelector('.ll-nam-nguon').value;
      var oDich = hop.querySelector('.ll-nam-dich').value.trim();
      if (oNguon !== NAM_NGUON || oDich !== NAM_DICH) {
        window.alert('Thầy cô vừa sửa ô năm học nhưng chưa bấm "Xem lại".\n\n' +
          'Bảng bên dưới vẫn là số của ' + NAM_NGUON + ' → ' + NAM_DICH + '. ' +
          'Bấm "Xem lại" để máy đếm lại theo năm học mới gõ, rồi hãy thực hiện.');
        return;
      }
      var loiNam = loiNamDich(NAM_NGUON, NAM_DICH);
      if (loiNam) { window.alert(loiNam); return; }

      var anhXa = {}, trung = {}, loi = '';
      Array.prototype.slice.call(hop.querySelectorAll('#ll-bang tbody tr')).forEach(function (tr) {
        var o = tr.querySelector('.ll-lop-moi');
        if (!o) return;                       // dòng khối 5 — ra trường
        var ten = o.value.trim();
        if (!ten) return;                     // để trống = cố ý bỏ lớp này
        // Hai lớp cũ cùng trỏ về một lớp mới thì hai lớp bị gộp làm một —
        // có thể là CỐ Ý (dồn lớp sau sáp nhập), nhưng phải hỏi cho chắc.
        if (trung[ten]) loi = ten;
        trung[ten] = true;
        anhXa[tr.getAttribute('data-lop')] = ten;
      });
      if (!Object.keys(anhXa).length) {
        window.notify('Chưa có lớp nào được đặt tên lớp mới.'); return;
      }
      // Hai câu hỏi nối tiếp nhau. Hộp thoại của app trả Promise nên phải nối
      // chuỗi, không dùng được lối `if (!confirm(...)) return;` như trước.
      var hoiTrung = !loi ? Promise.resolve(true) : xinPhep(
        'Có từ hai lớp cũ cùng chuyển về lớp "' + loi + '" — các lớp đó sẽ dồn làm một.\n\n' +
        'Nếu là chủ ý dồn lớp sau sáp nhập thì bấm Dồn lớp. Nếu không, bấm Huỷ rồi sửa lại tên.',
        { tieuDe: 'Hai lớp dồn làm một', bieuTuong: '⚠️', nutOK: 'Dồn lớp', nguyHiem: true });

      hoiTrung.then(function (dongY) {
        if (!dongY) return;
        return xinPhep(
          'Chuyển học sinh từ năm học ' + NAM_NGUON + ' sang ' + NAM_DICH + '?\n\n' +
          '· ' + tong.len + ' em lên lớp\n' +
          '· ' + tong.ra + ' em hoàn thành chương trình tiểu học (không tạo dòng năm mới)\n' +
          '· ' + tong.oLai + ' em ở lại lớp — nhà trường tự xếp lớp sau\n' +
          '· ' + tong.chua + ' em chưa có kết quả — KHÔNG được chuyển\n\n' +
          'Không xoá gì của năm cũ, và chạy lại được.',
          { tieuDe: 'Chuyển sang năm học ' + NAM_DICH, bieuTuong: '🎓', nutOK: 'Thực hiện lên lớp' }
        ).then(function (chac) {
          if (!chac) return;
          return chuyenNam(nut, anhXa, hop);
        });
      });
    });
  }

  // Tách riêng phần GHI để chỗ hỏi ở trên đọc được thành một mạch.
  function chuyenNam(nut, anhXa, hop) {
    var may = window.MAY_CHU;
    nut.disabled = true; nut.textContent = 'Đang chuyển…';
    return may.rpc('thuc_hien_len_lop',
      { p_nam_nguon: NAM_NGUON, p_nam_dich: NAM_DICH, p_anh_xa: anhXa })
      .then(function (r) {
        if (r.error) throw r.error;
        var k = r.data || {};
        var thieu = (k.lop_thieu_anh_xa || []);
        window.alert('✅ Đã chuyển sang năm học ' + NAM_DICH + '.\n\n' +
          '· Lớp mới tạo: ' + (k.lop_moi || 0) + '\n' +
          '· Học sinh chuyển sang: ' + (k.hoc_sinh_moi || 0) + '\n' +
          (thieu.length ? '· Bỏ qua vì chưa đặt tên lớp mới: ' + thieu.join(', ') + '\n' : '') +
          '\nCòn phải làm tay: xếp lớp cho ' + (k.o_lai_lop || 0) + ' em ở lại lớp, ' +
          'nạp học sinh lớp 1 tuyển mới và học sinh hai trường nhập về, ' +
          'rồi vào thẻ Cơ sở & Sáp nhập phân lớp mới về từng điểm trường.');
        if (window.hocSinhNoiLai) window.hocSinhNoiLai();
        veTabLL(hop);
      })
      .catch(function (e) {
        nut.disabled = false; nut.textContent = '🎓 Thực hiện lên lớp'; batLoi(e);
      });
  }

  // ══════════ ĐĂNG KÝ THẺ ══════════
  window.qtTabPhu = window.qtTabPhu || [];
  window.qtTabPhu.push({ ma: 'll', ten: '🎓 Lên lớp', ve: veTabLL });
})();

;} catch (e) { console.error("[goi.min.js] Lỗi khi nạp js/len-lop.js:", e); }
